import styled from 'styled-components';
import {getToken, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export const button = styled.div`
    ${dFlexCenter};
    width: 100%;
    gap: ${getSpacing('spaceSm')};
    padding: ${getSpacing('spaceSm')} 0;
    border-bottom: 1px solid ${getToken('color.border.subtle')};
    cursor: pointer;
    font-size: ${getFontSize('buttonPrimary')};
    font-weight: ${getFontWeight('semibold')};
    line-height: 20px;
    color: ${getToken('color.text.default')};

    &:last-child {
        border-bottom: none;
        padding-bottom: ${getSpacing('spaceLg')};
    }
`;
